module.exports = __webpack_public_path__ + "static/client_4-486f245f3cf954a4f82db2dea058a9bb.png";